import {Link} from '@github-ui/react-core/link'
import {Breadcrumbs, PageHeader} from '@primer/react'
import {clsx} from 'clsx'
import {type ComponentProps, type ReactNode, useEffect, useRef} from 'react'

import styles from './PropertiesBreadcrumbsPageHeader.module.css'

interface Props {
  pageTitle: string
  actions?: ReactNode
  className?: string
  breadcrumbLinkProps: Omit<ComponentProps<typeof Link>, 'ref'>
}

export function PropertiesBreadcrumbsPageHeader({actions, pageTitle, className, breadcrumbLinkProps}: Props) {
  const backToParentRef = useRef<HTMLAnchorElement>(null)
  useEffect(() => {
    window.scrollTo({top: 0})
    backToParentRef.current?.focus()
  }, [])

  return (
    <PageHeader className={clsx(className, styles.headerContainer)}>
      <PageHeader.TitleArea>
        <PageHeader.Title as="h2" className="h1-override-shared-component">
          {pageTitle}
        </PageHeader.Title>
      </PageHeader.TitleArea>
      <PageHeader.ContextArea hidden={false}>
        <PageHeader.ContextBar hidden={false}>
          <Breadcrumbs>
            <Breadcrumbs.Item ref={backToParentRef} as={Link} {...breadcrumbLinkProps}>
              Custom properties
            </Breadcrumbs.Item>
            <Breadcrumbs.Item selected>{pageTitle}</Breadcrumbs.Item>
          </Breadcrumbs>
        </PageHeader.ContextBar>
      </PageHeader.ContextArea>
      <PageHeader.Actions>{actions}</PageHeader.Actions>
    </PageHeader>
  )
}

try{ PropertiesBreadcrumbsPageHeader.displayName ||= 'PropertiesBreadcrumbsPageHeader' } catch {}